import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

export const gt95rcp8530 = new FeatureLayer({
    url: "https://njmaps1.rad.rutgers.edu/arcgis/rest/services/Climate/ZZ_TempGT95/MapServer/2",
    title: 'Number of Days above 95 Change until 2030',
    opacity: 0.4,
    oraId: 'gt95rcp8530',
  })